import { Injectable } from '@angular/core';
import { APPLICATION_NAME, APPLICATION_VERSION } from './config'
import { BUILD_ENVIRONMENT } from '../service-config';


interface IEnvironmentSettings {
    apiUrl: string
    apiUrlv1: string
    apiGrantType: string
    apiClientId: string
    apiClientSecret: string
    mdlogixSSO: string
    mdlogixSSOAssesment: string
    patientAvatarBucket: string
    twillioAuthToken: string
    twillioAuthSSID: string
    messagingServiceUrl: string
    applicationName: string
    applicationVersion: string
    applicationEnviroment: string
    bhLabworkOrderView: string;
    notifyApiUrl: string
}

class ProdEnvironmentSettings implements IEnvironmentSettings {
    apiUrl = 'https://services.memd.me/'
    apiUrlv1 = 'https://api.memd.me/v1/'
    apiGrantType = "password"
    apiClientId = "MobileProd_ClientAPI"
    apiClientSecret = "uKKewdhZcn6Jm1bz"
    mdlogixSSO = 'https://portal.memd.me'
    mdlogixSSOAssesment = 'https://memd-portal.mdlogix.com'
    patientAvatarBucket = 'https://memberavatar-prod.s3.amazonaws.com/'
    twillioAuthToken = 'bebd1d0435d0f9aabb31d579389f7a73';
    twillioAuthSSID = 'AC67dd8c834e5dd51b0434ab716be204b6';
    messagingServiceUrl = 'https://messaging.memd.me';
    applicationName = APPLICATION_NAME
    applicationVersion = APPLICATION_VERSION
    applicationEnviroment = 'PROD';
    bhLabworkOrderView = 'https://memd.secure.force.com/viewlab?intakeid='
    notifyApiUrl = 'https://notification.memd.me/'
}

class QaEnvironmentSettings extends ProdEnvironmentSettings {
    apiUrl = 'https://qa-services.memd.me/'
    apiUrlv1 = 'https://qa-api.memd.me/v1/'
    apiClientId = 'MeMD_ClientAPI'
    apiClientSecret = 'kZ6tp4aCgndvhaPr'
    mdlogixSSO = 'https://qa-portal.memd.me'
    mdlogixSSOAssesment = 'https://memd-portal-beta.mdlogix.com'
    patientAvatarBucket = 'https://memberavatar-stage.s3.amazonaws.com/'
    twillioAuthToken = '5e90c5c242bd080e2a807c1193e12853';
    twillioAuthSSID = 'AC45d4367a6a651e6bbfae0768427e8fc9';
    messagingServiceUrl = 'https://qa-messaging.memd.me';
    applicationName = APPLICATION_NAME
    applicationVersion = APPLICATION_VERSION
    applicationEnviroment = 'QA';
    bhLabworkOrderView = 'https://oct18-memd.cs60.force.com/viewlab?intakeid='
    notifyApiUrl = 'https://qa-notification.memd.me/'
}
class StageEnvironmentSettings extends ProdEnvironmentSettings {
    apiUrl = 'https://staging-services.memd.me/'
    apiUrlv1 = 'https://staging-api.memd.me/v1/'
    apiClientId = 'MeMD_ClientAPI'
    apiClientSecret = 'kZ6tp4aCgndvhaPr'
    mdlogixSSO = 'https://staging-portal.memd.me'
    mdlogixSSOAssesment = 'https://memd-portal-beta.mdlogix.com'
    patientAvatarBucket = 'https://memberavatar-stage.s3.amazonaws.com/'
    twillioAuthToken = '5e90c5c242bd080e2a807c1193e12853';
    twillioAuthSSID = 'AC45d4367a6a651e6bbfae0768427e8fc9';
    messagingServiceUrl = 'https://staging-messaging.memd.me';
    applicationName = APPLICATION_NAME
    applicationVersion = APPLICATION_VERSION
    applicationEnviroment = 'Stage';
    bhLabworkOrderView = 'https://oct18-memd.cs60.force.com/viewlab?intakeid='
    notifyApiUrl = 'https://staging-notification.memd.me/'
}

class DevEnvironmentSettings extends ProdEnvironmentSettings {
    apiUrl = 'https://dev-services.memd.me/'
    apiUrlv1 = 'https://dev-api.memd.me/v1/'
    apiClientId = 'MeMD_ClientAPI'
    apiClientSecret = 'kZ6tp4aCgndvhaPr'
    mdlogixSSO = 'https://dev-portal.memd.me'
    mdlogixSSOAssesment = 'https://memd-portal-beta.mdlogix.com'
    patientAvatarBucket = 'https://memberavatar-stage.s3.amazonaws.com/'
    twillioAuthToken = '5e90c5c242bd080e2a807c1193e12853';
    twillioAuthSSID = 'AC45d4367a6a651e6bbfae0768427e8fc9';
    messagingServiceUrl = 'https://dev-messaging.memd.me';
    applicationName = APPLICATION_NAME
    applicationVersion = APPLICATION_VERSION
    applicationEnviroment = 'Dev';
    bhLabworkOrderView = 'https://oct18-memd.cs60.force.com/viewlab?intakeid='
    notifyApiUrl = 'https://dev-notification.memd.me/'
}

class Area51EnvironmentSettings extends StageEnvironmentSettings {
    apiUrl = 'https://area51-services.memd.me/'
    apiUrlv1 = 'https://dev-api.memd.me/v1/'
    apiClientId = 'MeMD_ClientAPI'
    apiClientSecret = 'kZ6tp4aCgndvhaPr'
    mdlogixSSO = 'https://dev-portal.memd.me'
    mdlogixSSOAssesment = 'https://memd-portal-beta.mdlogix.com'
    patientAvatarBucket = 'https://memberavatar-stage.s3.amazonaws.com/'
    twillioAuthToken = '5e90c5c242bd080e2a807c1193e12853';
    twillioAuthSSID = 'AC45d4367a6a651e6bbfae0768427e8fc9';
    messagingServiceUrl = 'https://area51-messaging.memd.me';
    applicationName = APPLICATION_NAME
    applicationVersion = APPLICATION_VERSION
    applicationEnviroment = 'area51';
}

class LocalEnvironmentSettings extends StageEnvironmentSettings {
    apiUrl = 'http://www.memdplatform.lcl/'
    apiUrlv1 = 'http://www.memdapi.dev/'
    mdlogixSSO = 'https://stage-portal.memd.me'
    mdlogixSSOAssesment = 'https://memd-portal-beta.mdlogix.com'
    messagingServiceUrl = 'http://localhost:49578/'
    applicationName = APPLICATION_NAME
    applicationVersion = APPLICATION_VERSION
    applicationEnviroment = 'Local';
    bhLabworkOrderView = 'https://oct18-memd.cs60.force.com/viewlab?intakeid='
    notifyApiUrl = 'https://dev-notification.memd.me/'
}

@Injectable()
export class Environment {
    constructor() {
        console.log('-------------------------------------------------------------------------------------BUILD_ENVIRONMENT:', BUILD_ENVIRONMENT.trim().toLowerCase());

        switch (BUILD_ENVIRONMENT.trim().toLowerCase()) {
            case 'area51':
                this.settings = new Area51EnvironmentSettings()
                break;
            case 'l':
            case 'local':
            case 'debug':
                this.settings = new LocalEnvironmentSettings()
                break;
            case 'q':
            case 'qa':
                this.settings = new QaEnvironmentSettings()
                break;
            case 'd':
            case 'dev':
            case 'development':
                this.settings = new DevEnvironmentSettings()
                break;
            case 'prod':
            case 'produdction':
                this.settings = new ProdEnvironmentSettings()
                break;
            case 'stage':
            case 'staging':
                this.settings = new StageEnvironmentSettings()
                break;
            default:
                this.settings = new DevEnvironmentSettings()
                break;
        }
    }

    public settings: IEnvironmentSettings;
} 